import { connect } from 'react-redux'
import NumberSearch from './NumberSearch'
import showNumbersFormModal from 'features/Numbers/NumbersFormModal'
import { getAvailable1300Numbers } from 'features/Numbers1300/Numbers1300.actions'
import { getAvailable1800Numbers } from 'features/Numbers1800/Numbers1800.actions'

const stateToProps = ({ numbers1300, numbers1800 }, { tabs }) => ({
  form: `searchNumbers-${JSON.stringify(tabs)}`,
  availableNumbers1300: numbers1300.availableNumbers,
  availableNumbers1800: numbers1800.availableNumbers,
})

const dispatchToProps = {
  showNumbersFormModal,
  getAvailable1300Numbers,
  getAvailable1800Numbers,
}

export default connect(stateToProps, dispatchToProps)(NumberSearch)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumberSearch/NumberSearch.container.js